import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { Component, ElementRef, OnInit, viewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LocationModel } from '@app/modules/location/models/location.model';
import { LocationService } from '@app/core/services/location.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  imports: [SharedModule, RouterModule],
  selector: 'inspekt-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit {
  private locationsService = inject(LocationService);
  private router = inject(Router);


  readonly inputEl = viewChild<ElementRef>('location');

  public selectedLocation = new FormControl<LocationModel | null>(null);
  public locations: LocationModel[];
  public filteredLocations: Observable<LocationModel[]>;

  async ngOnInit() {
    this.locations = await this.locationsService.getAll().toPromise();

    this.filteredLocations = this.selectedLocation.valueChanges
      .pipe(startWith(null as LocationModel | null),
        map(value => {
          if (value && typeof value === 'object' && 'name' in value) {
            return value.name;
          }
          return (value as unknown as string) || '';
        }),
        map(name => name ? this.filter(name) : this.locations.slice())
      );
  }

  filter(name: string): LocationModel[] {
    return this.locations.filter(option =>
      option.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
  }

  displayFn(location?: LocationModel): string | undefined {
    return location ? location.name : undefined;
  }

  async locationSelected() {
    const selectedValue = this.selectedLocation.value;

    if (selectedValue) {
      this.locationsService.currentLocation = selectedValue;
    } else {
      return;
    }

    await this.router.navigateByUrl('/inspections');
  }
}
